import { render } from "./ClerkComponent.vue?vue&type=template&id=ad9587de&scoped=true"
const script = {}

import "./ClerkComponent.vue?vue&type=style&index=0&id=ad9587de&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-9\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad9587de"]])

export default __exports__